<template lang="pug">
div
    modal(v-show="isShowModal_",:titulo="'NUEVA ' + nameModulo.toUpperCase()" bindClass="col-md-4 col-sm-12" , @close="isShowModal_=false")
        div(slot='body')  
            .form-group
                .form-row
                    .col-md-12.col-sm-12
                        label Nombre de Usuario
                        input.form-control.form-control-sm(v-model="parameter.NameUser", @keypress.enter="sendInfo()") 
                .form-row
                    .col-md-12.col-sm-12
                        label Email
                        input.form-control.form-control-sm(v-model="parameter.Email")
                .form-row
                    .col-md-12.col-sm-12
                        label Contraseña
                        input.form-control.form-control-sm(v-model="parameter.Password", type="password")
                .form-row
                    .col-md-8.col-sm-12
                        label Cargo
                        input.form-control.form-control-sm(v-model="parameter.Position")
                    .col-md-4.col-sm-12
                        label Tipo de Cuenta
                        select.form-control.form-control-sm(v-model="parameter.TypeAccount")
                            option(value=1) Administrador
                            option(value=2) Supervisor
                            option(value=3) Colaborador 
                .form-row
                    .col-md-4.col-sm-12(v-if="parameter.IdEnterprise==7")
                        label Division
                        select.form-control.form-control-sm(v-model="parameter.IdDivision")
                            option(v-for="division in divisions" :key="division.IdDivision" :value="division.IdDivision") {{ division.DivisionName }}
                    .col-md-8.col-sm-12
                        label Habilitar como Responsable
                        div
                            i.fa.fa-toggle-off.fa-2x(v-if="parameter.IsResponsible==2", @click="parameter.IsResponsible=1")  OFF                                                    
                            i.fa.fa-toggle-on.fa-2x(v-if="parameter.IsResponsible==1" ,@click="parameter.IsResponsible=2" )   ON
        div(slot='footer')
            button.btn.btn-primary(@click="sendInfo()") Guardar
</template>
<script>
import modal from "../../../complementos/modal.vue"
import toolValidate from '../../../tools/validate.js'
import apiWeb from '../../../api/apiSLC.js'
export default {
    props:{ 
        nameModulo:String,
        IsShowModal:Boolean,
        parameter:Object
    },  
    components:{
        modal
    },
     data() {
         return {
            
            divisions:[]
         }
     },
    computed:{
        isShowModal_ :{
                        get(){return this.IsShowModal },
                        set(val){this.$emit("update:IsShowModal",val)}
        }
    },
     mounted(){
         this.fetchDivisions()
     },
    methods:{ 
            fetchDivisions() {
                    
                    apiWeb.post("Division/Division_View",{Active:1,DivisionName:'',IdEnterprise:this.parameter.IdEnterprise})
                    .then(result=>{
                        if(result.status==0){
                            this.divisions=JSON.parse(result.value)
                            
                        }
                        else{
                                            this.$msgbox.show(result.message,"Error nivel 1")
                                        }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
            }, 
                
            sendInfo(){
                if(this.validate()){
                    this.$emit("update:parameter",this.parameter)
                    this.$emit("sendInfo",this.parameter)
                }       
            },
            validate(){ 
                console.log(this.parameter.IdEnterprise)
                if(this.parameter.IdEnterprise=='0' || this.parameter.IdEnterprise=='' || this.parameter.IdEnterprise==null ){
                    this.$msgbox.show("No Hay Empresa Selecionada o Cargada","Alerta")
                    return false
                } 
                else if(this.parameter.NameUser=='' || this.parameter.NameUser==null ){
                    this.$msgbox.show("Ingrese Nombre de Usuario","Alerta")
                    return false
                } 
                else if(this.parameter.Email=='' || this.parameter.Email==null ){
                    this.$msgbox.show("Ingrese Email","Alerta")
                    return false
                }
                else if(this.parameter.Password=='' || this.parameter.Password==null ){
                    this.$msgbox.show("Ingrese Contraseña","Alerta")
                    return false
                }
                else if(this.parameter.TypeAccount=='' || this.parameter.TypeAccount==null ){
                    this.$msgbox.show("Selecione Tipo de Cuenta","Alerta")
                    return false
                }
                else{
                    return true
                }
            }
    }

    
}
</script>